<template>
  <!-- Modal -->
  <div class="modal fade" id="sensorListModal" tabindex="-1" aria-labelledby="sensorListModal" aria-hidden="true" >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel"> სენსორის დამატება</h5>
          <button type="button" class="btn-close" id="close-modal" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <transition name="fade" mode="out-in">
          <div class="modal-body">
            <table class="table" v-if="sensorList && sensorList.sensors && sensorList.sensors.length">
              <thead>
              <tr>
                <th>სერიული ნომერი</th>
                <th>ლოკაცია</th>
                <th>მოქმედება</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="sensor in sensorList.sensors" :key="sensor.id"  >
                <td  class="table-text-left">
                  {{ sensor.name }}
                </td>
                <td>
                  {{ sensor.warehouse }}
                </td>
                <td @click.prevent="addMarker(sensor)">
                  <img src="/svgs/add.svg" alt="">
                </td>
              </tr>
              </tbody>
            </table>
            <div v-else>
              სია ცარიელია
            </div>
          </div>
        </transition>
        <div class="modal-footer">

        </div>

      </div>
    </div>
  </div>

</template>

<script>

export default {
  name:'SensorListPopup',
  props:['sensorList'],
  computed:{

  },
  methods:{
    //todo whole function
    addMarker(sensor){
      //if we not in editing mode just activate
      if (!this.$parent.sensorEditingMode && this.$parent.activeToggle !== "table"){
        this.$parent.enterEditingMode(true)
      }
      //add draggable markers
      this.$parent.addMarkerToMap(sensor, 'extra-added-sensor', true)

      //todo
      if (this.$parent.activeToggle !== "table"){
        if (this.$parent.findSensorInActiveRoom(sensor.id) === null ){
          this.$parent.lastOpened.activeRoom.sensors.push(sensor)
        }
      }

    }
  },

}
</script>

<style>

.modal{
  z-index: 99999 !important;
}
.modal-backdrop{
  z-index: 8 !important;
}


</style>